export interface IUserDetails {
  firstName: string
  lastName: string
  email: string
  role: number
  status: number
  joinedDate: string | null
  lastLogin: string | null
  invitationValid: boolean | null
}

export enum UserStatus {
  Active = 2,
  Deactivated = 0,
  Invited = 1,
}
